import { render, staticRenderFns } from "./ScreenTranslucenciaNucalPerfilCervicalMorfologica1Trimestre.vue?vue&type=template&id=1809bca4&scoped=true&"
import script from "./ScreenTranslucenciaNucalPerfilCervicalMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalPerfilCervicalMorfologica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalPerfilCervicalMorfologica1Trimestre.vue?vue&type=style&index=0&id=1809bca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809bca4",
  null
  
)

export default component.exports